import type { Novidade } from './tipos';

/** Fase 2, W15: chat da equipe no menu Comunicação (módulo Equipe). */
export const novidadeEquipe: Novidade = {
  id: '2026-10-05-equipe',
  publicada_em: '2026-10-05',
  tipo: 'novo',
  modulo: 'equipe',
  permissao: 'equipe.ver',
  rota: '/comunicacao/equipe/chat',
  textos: {
    pt: {
      titulo: 'Chat da equipe no menu Comunicação',
      resumo: 'Converse com o time sem sair do sistema: conversa direta, grupos, canais de departamento e a discussão de qualquer registro.',
      passos: [
        'Em Comunicação, use Nova conversa para falar direto com alguém ou criar um grupo, público ou privado.',
        'Escreva @ para chamar alguém do canal: a pessoa recebe o aviso e, fora do sistema, o push.',
        'Anexe arquivos, responda citando, edite ou apague a sua mensagem. O número no menu mostra o que você ainda não leu.',
        'Na atividade de um registro, Discutir com a equipe abre a conversa daquele registro, com o link de volta para ele.',
      ],
    },
    en: {
      titulo: 'Team chat in the Communication menu',
      resumo: 'Talk to the team without leaving the system: direct conversations, groups, department channels and the discussion of any record.',
      passos: [
        'In Communication, use New conversation to talk directly to someone or create a group, public or private.',
        'Type @ to call someone in the channel: the person gets the notice and, outside the system, the push.',
        'Attach files, reply quoting, edit or delete your message. The number in the menu shows what you have not read yet.',
        'In the activity of a record, Discuss with the team opens the conversation about that record, with the link back to it.',
      ],
    },
    es: {
      titulo: 'Chat del equipo en el menú Comunicación',
      resumo: 'Habla con el equipo sin salir del sistema: conversación directa, grupos, canales de departamento y la discusión de cualquier registro.',
      passos: [
        'En Comunicación, usa Nueva conversación para hablar directo con alguien o crear un grupo, público o privado.',
        'Escribe @ para llamar a alguien del canal: la persona recibe el aviso y, fuera del sistema, el push.',
        'Adjunta archivos, responde citando, edita o borra tu mensaje. El número en el menú muestra lo que aún no leíste.',
        'En la actividad de un registro, Hablar con el equipo abre la conversación de ese registro, con el enlace de vuelta.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-equipe/chat.webp', null, null, null],
  treinamento: { curso: 'novidades' },
};
